const VersionNo = {
  type: 'string',
  pattern: '^(\\d+)(\\.\\d+){2}$',
};

export default VersionNo;
